// eslint-disable-next-line import/prefer-default-export
export var APPEARANCES = {
  standard: {
    color: "neutral",
    variant: "subtle",
    spinnerColor: null,
    shortcutsVariant: "onUiElementBackground"
  },
  onSurface: {
    color: "neutral",
    variant: "onSurface",
    spinnerColor: null,
    shortcutsVariant: "onSurfaceBackground"
  },
  primary: {
    color: "primary",
    variant: "solid",
    spinnerColor: "primary",
    shortcutsVariant: "onSolidBackground"
  },
  destructive: {
    color: "critical",
    variant: "solid",
    spinnerColor: "critical",
    shortcutsVariant: "onSolidBackground"
  },
  warning: {
    color: "warning",
    variant: "solid",
    spinnerColor: "warning",
    shortcutsVariant: "onSolidBackground"
  },
  ghost: {
    color: "neutral",
    variant: "ghost",
    spinnerColor: null,
    shortcutsVariant: "ghost"
  },
  link: {
    color: "primary",
    variant: "link",
    spinnerColor: null,
    shortcutsVariant: "link"
  }
};